import React from "react";
import "../../../_css/Reporting.css";
import CustomTokenChart from "./CustomTokenChart";

const TokenUsedChart = ({
  heygenTokens,
  text = "Token Used",
  color = "#EAB308",
}) => {
  return (
    <div className="box-con">
      <div className="admin-header di-flex">
        <div className="heading-subtext">{text}</div>
        {/* <DropDown options={["This month", "This week", "This year"]} data={performancePeriod} setData={setPerformancePeriod}/> */}
      </div>

      {heygenTokens && (
        <div
          className="admin-content"
          style={{ width: "100%", height: "300px", backgroundColor: "white" }}
        >
          <CustomTokenChart
            title="Token Used"
            xData={[...Object.keys(heygenTokens)]}
            expectedData={[...Object.values(heygenTokens)]}
            barColor={color}
            lineColor="#06B6D4"
            showPlaceholder={true}
          />
        </div>
      )}
    </div>
  );
};

export default TokenUsedChart;
